/**
 *  RaceMover
 *
 *  Created by Legman on 21/03/2017.
 *
 */

import Point4       from "./Point4";
import RaceEntity   from "./RaceEntity";

/**
 * @class
 * @extends RaceEntity
 * @memberOf race
 */
export default class RaceMover extends RaceEntity {
    /**
     * @param {DisplayObject} view
     */
    constructor(view) {
        super(RaceEntity.TYPE_MOVING, view);

        /**
         * @member {signals.Signal}
         */
        this.signals.lap = new signals.Signal();

        /**
         * @member {number}
         */
        this.acceleration = 0;

        /**
         * @member {number}
         */
        this.turnAccel = 0;

        /**
         * @member {number}
         */
        this.turnSpeed = 0;

        /**
         * @member {number}
         */
        this.velocity = 0;

        /**
         * @member {number}
         */
        this.turnVelocity = 0;

        /**
         * @member {number}
         */
        this.linearDamping = 0.99;

        /**
         * @member {number}
         */
        this.turnDamping = 0.99;

        /**
         * @member {boolean}
         */
        this.moving = false;

        /**
         * @member {number}
         */
        this.lap = 0;

        /**
         * @member {Point4}
         * @protected
         */
        this._heading = new Point4();

        /**
         * @type {number}
         * @protected
         */
        this._lastDistance = 0;
    }

    /**
     */
    init() {
        this._lastDistance = this.distance;
    }

    /**
     */
    destroy() {
        this.signals.lap.dispose();

        super.destroy();
    }

    /**
     * @param {number} dt
     */
    update(dt) {
        super.update(dt);

        this.moving && (this.velocity += this.acceleration * dt);
        this.velocity *= this.linearDamping;
        this.distance += this.velocity * dt;

        this.turnVelocity += this.turnSpeed * dt;
        this.turnVelocity *= this.turnDamping;
        this.offset.x += this.turnVelocity * dt;

        if (Math.abs(this.velocity) < 0.01) this.velocity = 0;
        if (Math.abs(this.turnVelocity) < 0.01) this.turnVelocity = 0;
    }

    /**
     */
    postTransform() {
        this.updateLap();
    }

    /**
     */
    updateLap() {
        if (this.distance < this._lastDistance) {
            ++ this.lap;
            this.signals.lap.dispatch(this, this.lap);
        }
        this._lastDistance = this.distance;
    }

    /**
     * @returns {Point4}
     */
    getHeading() {
        const p1 = this.worldPosition;
        const p2 = this.engine.getPointAt(this.distance + Math.max(0.001, this.velocity));

        this._heading.x = p2.x - p1.x;
        this._heading.y = p2.y - p1.y;
        this._heading.z = p2.z - p1.z;
        this._heading.w = 1;

        const length = Math.sqrt(
            this._heading.x * this._heading.x + this._heading.y * this._heading.y + this._heading.z * this._heading.z);

        this._heading.x /= length;
        this._heading.y /= length;
        this._heading.z /= length;

        if (isNaN(this._heading.x + this._heading.y + this._heading.z)) {
            alert(length);
        }
        return this._heading;
    }

    /**
     * @param {RaceMover} mover
     * @returns {number}
     */
    getDotTo(mover) {
        const h1 = this.getHeading();
        const h2 = mover.getHeading();
        return h1.x * h2.x + h1.y * h2.y;
    }

    /**
     * @param {RaceCar} mover
     * @returns {number}
     */
    getPerpTo(mover) {
        const h1 = this.getHeading();
        const h2 = mover.getHeading();
        return h1.y * h2.x + -h1.x * h2.y;
    }

    /**
     * @returns {number}
     */
    getTotalDistance() {
        const d = this.distance;
        const l = this.engine.track.length * this.lap;
        return d + l;
    }

    /**
     * @param {RaceMover} mover
     */
    getDistanceTo(mover) {
        const a = this.getTotalDistance();
        let b = mover.getTotalDistance();
        let diff = b - a;

        const sign = diff !== 0 ? diff / Math.abs(diff) : 0;
        if (sign === -1) {
            while (diff < this.engine.track.length * -0.5) {
                diff += this.engine.track.length;
            }
        } else if (sign === 1) {
            while (diff > this.engine.track.length * 0.5) {
                diff -= this.engine.track.length;
            }
        }
        return diff;
    }
}